import { FC } from 'react';

import styled, { css } from 'styled-components';

import SecondaryButton from 'components/secondary-button';

import DirectionsLink from './directions-link';
import theme from './theme';

export interface IStoreCardContainer {
  isListView?: boolean;
}

const notListViewCss = css`
  ${Styles.mobileSmall`
    width: 90vw;
  `}
`;

export const StoreCardContainer = styled.div<IStoreCardContainer>`
  position: relative;
  width: ${p => (p.isListView ? '100%' : '25rem')};
  margin-bottom: ${p => (p.isListView ? '0.5rem' : 'auto')};
  background: ${Styles.color.cardBackground};
  padding: 1rem 1.125rem;
  overflow: hidden;
  border-radius: ${Styles.borderRadius};
  box-shadow: ${Styles.boxShadow};
  display: flex;
  justify-content: center;
  flex-direction: column;

  ${p => !p.isListView && notListViewCss}

  ${Styles.desktop`
    width: 100%;
    margin-bottom: 0.5rem;
  `}
`;

export const SelectedBorder = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 3px;
  background: ${Styles.color.primary};
  width: 100%;
`;

export const SelectedBorderVertical = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 3px;
  background: ${Styles.color.primary};
  height: 100%;
`;

const determineAddressHeaderMaxWidth = (
  favoritesEnabled: boolean | undefined,
  diagnosticsEnabled: boolean | undefined
) => {
  if (!favoritesEnabled && !diagnosticsEnabled) {
    return '100%';
  }

  if (favoritesEnabled && diagnosticsEnabled) {
    return 'calc(100% - 70px)';
  }

  return 'calc(100% - 30px)';
};

export const AddressHeader = styled.div<{
  favoritesEnabled?: boolean;
  areDiagnosticsEnabled?: boolean;
}>`
  align-items: center;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: ${p => determineAddressHeaderMaxWidth(p.favoritesEnabled, p.areDiagnosticsEnabled)};

  h2 {
    color: ${Styles.color.black};
    font-family: ${Styles.fontFamily.base};
    margin: 0;
    text-transform: ${theme.addressTextTransform};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const AddressSubheader = styled.div`
  margin-bottom: 0.5rem;

  p {
    color: ${Styles.color.grey.one};
    font-size: 0.875rem;
    line-height: 1;
    margin: 0;
    text-transform: capitalize;
  }
`;

export const ActionContainer = styled.div`
  display: flex;

  > :first-child {
    margin-right: 5px;
  }

  > :last-child {
    margin-left: 5px;
  }
`;

export const Divider: FC = () => null;

export const TimeAndInfoWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 0;
  margin-bottom: 0.875rem;

  div:nth-child(1) {
    justify-content: flex-start;
  }

  p {
    margin: 0 6px;
  }
`;

export const TimeNoteWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 0;
  margin-bottom: 0.875rem;

  div:nth-child(1) {
    justify-content: flex-start;
  }

  p {
    margin: 0 6px;
  }
`;

export const TimeNote = styled.div<{ open: boolean }>`
  align-items: center;
  display: flex;
  justify-content: center;
  text-align: center;

  p {
    color: ${Styles.color.grey.one};
    display: inline-block;
    font-size: 0.8rem;
    line-height: 1;
    margin: 0;
  }
  svg {
    fill: ${Styles.color.grey.one};
    margin: 0 0.5rem 0 0;
  }
  span {
    color: ${p => (p.open ? Styles.color.validated : Styles.color.error)};
  }
`;

export const MoreInfoLink = styled.a``;

export const MoreInfoButton = styled(SecondaryButton)`
  width: 100%;
  max-width: 50%;
  && {
    margin: auto;
  }
`;

export const SubheaderContainer: FC = () => null;

export const DirectionsLinkStyled = styled(DirectionsLink)`
  display: flex;
  flex: 0 1;
  align-self: flex-start;
  margin-bottom: 0.5rem;
`;
